/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import ProgressBar from "../common_spinner/ProgressBar";
import SS_TIPE_POI from "./SS_TIPE_POI";
import SS_DEMO from "./SS_DEMO";
import SS_FORMULA from "./SS_FORMULA";
import SS_RESULT_TEMP from "./SS_RESULT_TEMP";

/*REDUX*/
import {
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  set_value_insight,
} from "../../App/actions/insight_v2";
import { run_site_selection } from "../../App/actions/site_selections";
import { importLayer } from "../../App/actions/layerNewActions";

/*PICTURE*/
import ICON_FULL_MODE from "../../Assets/jsx/ICON_FULL_MODE";

/*FUNCTION*/
import generate_uuid from "../../App/validation/generate_uuid";
import format_date_formal from "../../App/validation/format_date_formal";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const SS_MANUAL = ({
  auth,
  project,
  insight_reducer,
  loading_reducer,
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  run_site_selection,
  importLayer,
  set_value_insight,
}) => {
  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  const [state, setState] = useState({
    modal_choose_poi: false,
    modal_demography: false,
    modal_warning: false,
  });

  const { modal_choose_poi, modal_demography, modal_warning } = state;

  //global props
  const {
    provinsi,
    kota,
    kecamatan,
    kelurahan,
    tipe_1_array,
    tipe_2_array,
    tipe_3_array,
    tipe_level,
    tipe_1_all,
    array_formula_insight,
    total_poi,
    current_progress_poi,
    total_demo,
    current_progress_demo,
    total_grid_group,
    current_grid_group,
    total_formula,
    current_formula,
    step_ss,
    modal_ss_done,
    error_object_area,
    modal_error_area,
    error_object_poi,
    modal_error_poi,
    response_ai_demo,
    response_ai_poi,
  } = insight_reducer;
  const { loading_item_array } = loading_reducer;

  const array_formula_insight_demo = array_formula_insight.filter(
    (item) => item.group === "demography"
  );

  useEffect(() => {
    const { list_tipe_1, list_tipe_2, list_tipe_3 } = insight_reducer;
    if (list_tipe_1.length === 0) {
      get_list_tipe_1();
    }
    if (list_tipe_2.length === 0) {
      get_list_tipe_2();
    }
    if (list_tipe_3.length === 0) {
      get_list_tipe_3();
    }
  }, [insight_reducer, get_list_tipe_1, get_list_tipe_2, get_list_tipe_3]);

  // Auto-scroll effect when loading states change
  useEffect(() => {
    if (loading_item_array.includes("template_poi")) {
      const container = document.getElementById("poi_container");
      if (container) {
        container.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
    if (loading_item_array.includes("template_demo")) {
      const container = document.getElementById("demo_container");
      if (container) {
        container.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  }, [loading_item_array]);

  const toggle_warning = () => {
    setState((prevState) => ({
      ...prevState,
      modal_warning: !prevState.modal_warning,
    }));
  };

  const toggle_demography = () => {
    setState((prevState) => ({
      ...prevState,
      modal_demography: !prevState.modal_demography,
    }));
  };

  const toggle_choose_poi = () => {
    setState((prevState) => ({
      ...prevState,
      modal_choose_poi: !prevState.modal_choose_poi,
    }));

    let array_formula_insight = insight_reducer.array_formula_insight;
    const key_list_old = array_formula_insight.map((formula) => formula.key);
    if (tipe_level === "tipe_1" || tipe_1_all) {
      tipe_1_array.forEach((item) => {
        const key = item.TIPE_1;
        //cek apakah sudah ada atau belum, jika sudah ada tidak perlu push
        if (!key_list_old.includes(key)) {
          array_formula_insight.push({
            ...item,
            key,
            is_directly_proportional: true,
            min: 0,
            max: 0,
            weight_score: 1,
            group: "poi",
          });
        }
      });
    } else if (tipe_level === "tipe_2") {
      tipe_2_array.forEach((item) => {
        const key = item.TIPE_2 + ", " + item.TIPE_1;
        //cek apakah sudah ada atau belum, jika sudah ada tidak perlu push
        if (!key_list_old.includes(key)) {
          array_formula_insight.push({
            ...item,
            key,
            is_directly_proportional: true,
            min: 0,
            max: 0,
            weight_score: 1,
            group: "poi",
          });
        }
      });
    } else if (tipe_level === "tipe_3") {
      tipe_3_array.forEach((item) => {
        const key = item.TIPE_3 + ", " + item.TIPE_2 + ", " + item.TIPE_1;
        //cek apakah sudah ada atau belum, jika sudah ada tidak perlu push
        if (!key_list_old.includes(key)) {
          array_formula_insight.push({
            ...item,
            key,
            is_directly_proportional: true,
            min: 0,
            max: 0,
            weight_score: 1,
            group: "poi",
          });
        }
      });
    }
    set_value_insight({
      key: "array_formula_insight",
      value: array_formula_insight,
    });
  };

  const on_run = () => {
    const body = {
      provinsi,
      kota,
      kecamatan,
      kelurahan,
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,
    };

    run_site_selection(body);
  };

  const on_save_layer = () => {
    const {
      provinsi,
      kota,
      kecamatan,
      kelurahan,

      array_formula_insight,
      array_group_insight,
      config_final_score,

      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,

      total_poi_initial,
      grid_mode,
      grid_counts,
      grid_width_meters,
      total_square_meters,
    } = insight_reducer;
    const { geo_project } = project;
    const { domain } = auth;

    let features_grid = insight_reducer.features_grid;
    features_grid = features_grid.map((feature, idx) => {
      feature.idx = idx;
      feature.key = idx;
      feature.properties.key = idx;
      feature.properties.id = idx;
      feature.properties.ID_GRID = idx;
      return feature;
    });

    let fields = [];

    //fields auto genegerate ALL_POI_COUNT, FINAL_NUMBER_SCORE, FINAL_STATUS_SCORE,
    fields.push({
      uuid: generate_uuid(),
      key: "index",
      name: "Rank",
      description: "",
      unit: "",
      type: "number",
      isHighlight: false,
      isRequired: true,
      isHide: false,
      isStyle: false,
    });
    fields.push({
      uuid: generate_uuid(),
      key: "FINAL_NUMBER_SCORE",
      name: "Total Score",
      description: "",
      unit: "",
      type: "number",
      isHighlight: false,
      isRequired: true,
      isHide: false,
      isStyle: false,
    });
    fields.push({
      uuid: generate_uuid(),
      key: "FINAL_STATUS_SCORE",
      name: "Class",
      description: "",
      unit: "",
      type: "text",
      isHighlight: false,
      isRequired: true,
      isHide: false,
      isStyle: false,
    });

    fields.push({
      uuid: generate_uuid(),
      key: "ALL_POI_COUNT",
      name: "Total POI in Grid",
      description: "",
      unit: "",
      type: "number",
      isHighlight: false,
      isRequired: true,
      isHide: false,
      isStyle: false,
    });

    //fields dari formula (poi dan demografi) array_formula_insight
    const variants = [
      {
        suffix: "",
        label: "[Raw]",
        desc: "Nilai asli sebelum dilakukan perhitungan, misal jika POI maka jumlah POI yang ada di dalam poligon grid",
      },
      {
        suffix: "_NORMAL",
        label: "[Normalized]",
        desc: "Nilai setelah dilakukan proposional dibandingkan dengan minimal dan maksimal dari semua grid yang terlibat",
      },
      {
        suffix: "_WEIGHTED",
        label: "[Final]",
        desc: "Nilai akhir setelah dikalikan dengan bobot",
      },
    ];

    variants.forEach((variant) => {
      array_formula_insight.forEach((item) => {
        const base_key = item.key;
        let name = item.key;
        if (item.group === "poi") {
          if (tipe_level === "tipe_1") {
            name = item.TIPE_1;
          } else if (tipe_level === "tipe_2") {
            name = item.TIPE_2;
          } else {
            name = item.TIPE_3;
          }
        }
        fields.push({
          uuid: generate_uuid(),
          key: base_key + variant.suffix,
          name: `${variant.label} ${name}`,
          description: `${variant.label} ${base_key}. ${variant.desc}`,
          unit: "",
          type: "number",
          isHighlight: false,
          isRequired: true,
          isHide: false,
          isStyle: false,
        });
      });
    });

    fields.push({
      uuid: generate_uuid(),
      key: "ID_GRID",
      name: "ID_GRID",
      description: "",
      unit: "",
      type: "text",
      isHighlight: false,
      isRequired: true,
      isHide: false,
      isStyle: false,
    });

    const field_key = "FINAL_STATUS_SCORE";
    const style_array = [
      {
        key: "insight_color",
        field_key: field_key,
        paint_object: {
          "fill-opacity": 0.6,
          "fill-outline-color": "transparent",
          "line-color": "#000000",
          "line-width": 1,
          "line-opacity": 1,
          "fill-color": [
            "match",
            ["get", field_key],
            "Sangat Sesuai",
            "rgb(0,107,61)",
            "Sesuai",
            "rgb(128,181,30)",
            "Cukup Sesuai",
            "rgb(255,255,0)",
            "Tidak Sesuai",
            "rgb(246,137,11)",
            "Sangat Tidak Sesuai",
            "rgb(237,19,22)",
            "rgb(237,19,22)",
          ],
        },
        case_recomendation: "text",
        color_logic: "by_text",
        color_mode: "green_to_yellow_to_red",
        value_array: [
          "Sangat Sesuai",
          "Sesuai",
          "Cukup Sesuai",
          "Tidak Sesuai",
          "Sangat Tidak Sesuai",
        ],
        type_of_object: {
          string: 5,
        },
        type_of_array: [
          {
            key: "string",
            value: 5,
          },
        ],
        min: 0,
        max: 100,
        is_number_count: 0,
        steps: 5,
        constant_color: "#a0d062",
        style_type: "fill",
      },
    ];

    const insight_object = {
      is_insight: true,
      version: 3,
      array_formula_insight,
      array_group_insight,
      config_final_score,
      provinsi,
      kota,
      kecamatan,
      kelurahan,
      tipe_1_array,
      tipe_2_array,
      tipe_3_array,
      tipe_level,
      tipe_1_all,
      total_poi_initial,
      grid_mode,
      grid_counts,
      grid_width_meters,
      total_square_meters,
    };
    const geojson = {
      type: "FeatureCollection",
      features: features_grid,
    };
    const body = {
      name: `[SITE SELECTION] ${kota} ${format_date_formal(Date.now())}`,
      description: "",
      type: "Polygon",
      user_id: auth?.user?._id,
      folder: "",
      geo_project_id: geo_project?._id,
      fields,
      geojson,
      status: "site_selection",
      domain,
      style_array,
      default_style_key: "insight_color",
      is_cluster: false,
      is_use_new_style: true,
      is_show_and_fly: true,
      insight_object,
    };
    importLayer(body, false);
  };

  const toggle_ss_done = () => {
    set_value_insight({
      key: "modal_ss_done",
      value: !modal_ss_done,
    });
  };

  const toggle_error_area = () => {
    set_value_insight({
      key: "modal_error_area",
      value: !modal_error_area,
    });
  };

  const toggle_error_poi = () => {
    set_value_insight({
      key: "modal_error_poi",
      value: !modal_error_poi,
    });
  };

  const modal_warning_content = modal_warning && (
    <Modal
      modalSize="small"
      id="modal_warning"
      isOpen={modal_warning}
      onClose={toggle_warning}
    >
      <div className="box-body">
        <h1 className="text_big margin_bottom_extra">
          {dict?.["Please complete the parameters"]?.[language]}
        </h1>
        <p className="text_bold sub_color margin_bottom">
          {
            dict?.[
              "Complete the area you want to search and at least one formula parameter."
            ]?.[language]
          }
        </p>
        <br />
        <section className="text_center">
          <button
            className="button_big button_white outline_black"
            onClick={toggle_warning}
          >
            Okay!
          </button>
        </section>
      </div>
    </Modal>
  );

  const modal_ss_done_content = modal_ss_done && (
    <Modal
      modalSize="small"
      id="modal_ss_done"
      isOpen={modal_ss_done}
      onClose={toggle_ss_done}
    >
      <div className="box-body">
        <h1 className="text_big margin_bottom_extra">
          {dict?.["Site Selection Complete"]?.[language]}
        </h1>
        <p className="text_bold sub_color margin_bottom">
          {
            dict?.[
              "You still can modify the formula and see changes on the map."
            ]?.[language]
          }
        </p>
        <p className="text_bold sub_color margin_bottom_extra">
          {
            dict?.["Don't forget to save results as a new layer when done"]?.[
              language
            ]
          }
        </p>
        <section className="text_center">
          <button
            className="button_big button_white outline_black"
            onClick={toggle_ss_done}
          >
            Okay
          </button>
        </section>
      </div>
    </Modal>
  );

  const modal_choose_poi_content = modal_choose_poi && (
    <Modal
      modalSize="medium"
      id="modal_choose_poi"
      isOpen={modal_choose_poi}
      onClose={toggle_choose_poi}
    >
      <div className="box-body">
        <SS_TIPE_POI toggle_choose_poi={toggle_choose_poi} />
      </div>
    </Modal>
  );

  const modal_demography_content = modal_demography && (
    <Modal
      modalSize="medium"
      id="modal_demography"
      isOpen={modal_demography}
      onClose={toggle_demography}
    >
      <div className="box-body">
        <SS_DEMO />
      </div>
    </Modal>
  );

  const modal_error_area_content = modal_error_area && (
    <Modal
      modalSize="medium"
      id="modal_error_area"
      isOpen={modal_error_area}
      onClose={toggle_error_area}
    >
      <div className="box-body">
        <p className="text_big">
          {dict?.["Error obtaining demographic data"]?.[language]}
        </p>
        <p className="text_small">{dict?.["Error message"]?.[language]}</p>
        <p className="text_bold">{error_object_area?.message}</p>
        <br />
        <p className="text_small">{dict?.["Name"]?.[language]}</p>
        <p className="text_bold">{error_object_area?.name}</p>
        <br />
        <p className="text_small">Stack</p>
        <p className="text_bold">{error_object_area?.stack}</p>
      </div>
    </Modal>
  );

  const modal_error_poi_content = modal_error_poi && (
    <Modal
      modalSize="medium"
      id="modal_error_poi"
      isOpen={modal_error_poi}
      onClose={toggle_error_poi}
    >
      <div className="box-body">
        <p className="text_big">
          {dict?.["Error obtaining POI data"]?.[language]}
        </p>
        <p className="text_small">{dict?.["Error message"]?.[language]}</p>
        <p className="text_bold">{error_object_poi?.message}</p>
        <br />
        <p className="text_small">{dict?.["Name"]?.[language]}</p>
        <p className="text_bold">{error_object_poi?.name}</p>
        <br />
        <p className="text_small">Stack</p>
        <p className="text_bold">{error_object_poi?.stack}</p>
      </div>
    </Modal>
  );

  return (
    <main className="margin_bottom_extra">
      {modal_error_area_content}
      {modal_error_poi_content}
      {modal_warning_content}
      {modal_choose_poi_content}
      {modal_demography_content}
      {modal_ss_done_content}

      <section>
        <p className="text_medium sub_color margin_bottom">
          {dict?.["POI Parameters"]?.[language]}
        </p>

        <div
          onClick={toggle_choose_poi}
          className="button_with_icon button_white outline_black"
          data-mapid="clickOpenParameter"
        >
          {dict?.["Open"]?.[language]}

          <ICON_FULL_MODE
            color="#000"
            style={{ width: "17px", marginLeft: "10px" }}
          />
        </div>

        <section
          className={`container background_grey_light margin_top ${
            loading_item_array.includes("template_poi") &&
            "glowing_outline_radius"
          }`}
          id="poi_container"
        >
          <p className="text_medium margin_bottom">
            {dict?.["Selected parameter"]?.[language]}
          </p>
          <div style={{ maxHeight: "75px", overflowY: "auto" }}>
            {tipe_level === "tipe_1" ? (
              <>
                {tipe_1_array.map((item, idx) => {
                  return (
                    <div
                      className="badge_small background_white margin_right margin_bottom"
                      key={idx}
                    >
                      {item.TIPE_1}
                    </div>
                  );
                })}
              </>
            ) : tipe_level === "tipe_2" ? (
              <>
                {tipe_2_array.map((item, idx) => {
                  return (
                    <div
                      className="badge_small background_white margin_right margin_bottom"
                      key={idx}
                    >
                      {item.TIPE_2}
                    </div>
                  );
                })}
              </>
            ) : (
              <>
                {tipe_3_array.map((item, idx) => {
                  return (
                    <div
                      className="badge_small background_white margin_right margin_bottom"
                      key={idx}
                    >
                      {item.TIPE_3}
                    </div>
                  );
                })}
              </>
            )}
          </div>

          <hr />

          <div className="three_container">
            <p className="text_medium">
              {dict?.["Selected level"]?.[language]}
            </p>
            <div className="badge_small background_white">
              {tipe_1_all ? dict?.["ALL"]?.[language] : tipe_level}
            </div>
            <div className="badge_small background_white">
              {tipe_level === "tipe_1" ? (
                <>{tipe_1_array.length}</>
              ) : tipe_level === "tipe_2" ? (
                <>{tipe_2_array.length}</>
              ) : (
                <>{tipe_3_array.length}</>
              )}{" "}
              items
            </div>
          </div>
          {response_ai_poi && (
            <section className="container background_white margin_top">
              <p className="text_medium sub_color">{response_ai_poi}</p>
            </section>
          )}
        </section>

        <hr
          style={{
            border: "none",
            height: "3px",
            backgroundColor: "#cbd1d8",
            borderRadius: "1.5px",
            margin: "20px 0",
          }}
        />

        <p className="text_medium sub_color margin_bottom">
          {dict?.["Demographic Parameters"]?.[language]}
        </p>
        <div
          onClick={toggle_demography}
          className="button_with_icon button_white outline_black"
          data-mapid="clickOpenParameterDemografi"
        >
          {dict?.["Open"]?.[language]}

          <ICON_FULL_MODE
            color="#000"
            style={{ width: "17px", marginLeft: "10px" }}
          />
        </div>

        <section
          className={`container background_grey_light margin_top ${
            loading_item_array.includes("template_demo") &&
            "glowing_outline_radius"
          }`}
          id="demo_container"
        >
          <p className="text_medium margin_bottom">
            {dict?.["Selected parameter"]?.[language]}
          </p>
          <div style={{ maxHeight: "75px", overflowY: "auto" }}>
            {array_formula_insight_demo.map((item, idx) => {
              return (
                <p
                  key={idx}
                  className="badge_small background_white margin_right margin_bottom"
                >
                  {item.key}
                </p>
              );
            })}
          </div>
          {response_ai_demo && (
            <section className="container background_white margin_top">
              <p className="text_medium sub_color">{response_ai_demo}</p>
            </section>
          )}
        </section>

        <hr
          style={{
            border: "none",
            height: "3px",
            backgroundColor: "#cbd1d8",
            borderRadius: "1.5px",
            margin: "20px 0",
          }}
        />

        <p className="text_medium sub_color margin_bottom">
          {dict?.["Set Formula"]?.[language]}
        </p>
        <SS_FORMULA />

        <hr
          style={{
            border: "none",
            height: "3px",
            backgroundColor: "#cbd1d8",
            borderRadius: "1.5px",
            margin: "20px 0",
          }}
        />

        <section className="text_center margin_bottom_extra">
          {!kota || !array_formula_insight?.length ? (
            <button
              className="button_big red_container outline_black"
              onClick={toggle_warning}
            >
              {dict?.["Run Site Selection"]?.[language]}
            </button>
          ) : !loading_item_array.includes("run_site_selection") ? (
            <button
              className="button_big button_white outline_black"
              onClick={on_run}
              data-mapid="clickRunSiteSelection"
            >
              {dict?.["Run Site Selection"]?.[language]}
            </button>
          ) : (
            <button className="button_big button_white outline_black">
              {dict?.["Running Site Selection Process"]?.[language]}
            </button>
          )}
        </section>

        <section className="container background_grey_light margin_bottom_extra">
          <ProgressBar
            current_number={current_progress_demo}
            total_number={total_demo}
            name={dict?.["Loading Demographic Data"]?.[language]}
            is_hide_count={true}
            is_loading={loading_item_array.includes("get_area")}
            color="#000"
          />
          {error_object_area?.message && (
            <button
              className="button_small background_black"
              onClick={toggle_error_area}
            >
              {dict?.["Open error message"]?.[language]}
            </button>
          )}
          <hr />
          <ProgressBar
            current_number={current_progress_poi}
            total_number={total_poi}
            name={dict?.["Loading POI Data"]?.[language]}
            is_hide_count={true}
            is_loading={loading_item_array.includes("get_poi")}
            color="#000"
          />
          {error_object_poi?.message && (
            <button
              className="button_small background_black"
              onClick={toggle_error_poi}
            >
              {dict?.["Open error message"]?.[language]}
            </button>
          )}
          <hr />
          <ProgressBar
            current_number={current_grid_group}
            total_number={total_grid_group}
            name={dict?.["Creating the Grids"]?.[language]}
            is_hide_count={true}
            is_loading={loading_item_array.includes("run_grid")}
            color="#000"
          />
          <hr />
          <ProgressBar
            current_number={current_formula}
            total_number={total_formula}
            name={dict?.["Running the Formula"]?.[language]}
            is_hide_count={true}
            is_loading={loading_item_array.includes("run_formula")}
            color="#000"
          />
        </section>

        {step_ss === 4 && (
          <section>
            <SS_RESULT_TEMP />
            <div className="text_center">
              <button
                className="button_big button_white outline_black margin_bottom"
                onClick={on_save_layer}
                data-mapid="clickSaveAsNewLayer"
              >
                {dict?.["Save As New Layer"]?.[language]}
              </button>
            </div>
          </section>
        )}
      </section>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  map: state.map,
  layer: state.layer,
  project: state.project,
  payment: state.payment,
  properties: state.properties,
  sini: state.sini,
  license_reducer: state.license_reducer,
  insight_reducer: state.insight_reducer,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, {
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3,
  run_site_selection,
  importLayer,
  set_value_insight,
})(SS_MANUAL);
